import { render } from "./passwordTab.vue?vue&type=template&id=7367982a&scoped=true"
import script from "./passwordTab.vue?vue&type=script&setup=true&lang=js"
export * from "./passwordTab.vue?vue&type=script&setup=true&lang=js"

import "./passwordTab.vue?vue&type=style&index=0&id=7367982a&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7367982a"],['__file',"pages/EndataAuth/Account/App/components/profile/my/passwordTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7367982a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7367982a', __exports__)) {
    api.reload('7367982a', __exports__)
  }
  
  module.hot.accept("./passwordTab.vue?vue&type=template&id=7367982a&scoped=true", () => {
    api.rerender('7367982a', render)
  })

}


export default __exports__